import { getToken } from "./wechatAuth";

const BASE_URL =
  process.env.VUE_APP_BASE_API || "https://taxpay.gkdltech.com";

function resolveUrl(url) {
  if (url.startsWith("http")) return url;
  const path = url.startsWith("/") ? url : `/${url}`;
  if (!BASE_URL) return path;
  if (BASE_URL.endsWith("/") && path.startsWith("/")) {
    return BASE_URL.slice(0, -1) + path;
  }
  return `${BASE_URL}${path}`;
}

function getHeaders() {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    token: token,
  };
}

function parseResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return res.json();
  }
  // 非 JSON 响应（如 HTML 错误页、空响应）
  return res.text().then((text) => {
    try {
      return JSON.parse(text);
    } catch (e) {
      return { code: "-1", message: "服务器返回异常" };
    }
  });
}

export function httpGet(url, params = {}) {
  const fullUrl = resolveUrl(url);
  const queryString = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");
  const finalUrl = queryString ? `${fullUrl}?${queryString}` : fullUrl;

  return fetch(finalUrl, {
    method: "GET",
    headers: getHeaders(),
  })
    .then((res) => parseResponse(res))
    .catch((err) => {
      console.error("[请求错误]", err);
      throw err;
    });
}

/** GET + query，不带 JSON Content-Type，避免网关丢掉 merId */
export function httpGetQuery(url, params = {}) {
  const token = getToken();
  const fullUrl = resolveUrl(url);
  const queryString = Object.keys(params)
    .filter((key) => params[key] !== null && params[key] !== undefined)
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");
  const finalUrl = queryString ? `${fullUrl}?${queryString}` : fullUrl;

  return fetch(finalUrl, {
    method: "GET",
    headers: {
      token: token,
      Accept: "application/json",
    },
  })
    .then((res) => parseResponse(res))
    .catch((err) => {
      console.error("[请求错误]", err);
      throw err;
    });
}

export function httpPost(url, data = {}) {
  const fullUrl = resolveUrl(url);

  return fetch(fullUrl, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(data),
  })
    .then((res) => parseResponse(res))
    .catch((err) => {
      console.error("[请求错误]", err);
      throw err;
    });
}

export function httpPostForm(url, data = {}) {
  const token = getToken();
  const fullUrl = resolveUrl(url);
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] !== null && data[key] !== undefined) {
      formData.append(key, data[key]);
    }
  });

  return fetch(fullUrl, {
    method: "POST",
    headers: {
      token: token,
    },
    body: formData,
  })
    .then((res) => parseResponse(res))
    .catch((err) => {
      console.error("[请求错误]", err);
      throw err;
    });
}

/** merId 放在 URL query，body 用 JSON。后端 request.getParameter 可读 query */
export function httpPostParams(url, data = {}) {
  const fullUrl = resolveUrl(url);
  const queryString = Object.keys(data)
    .filter((key) => data[key] !== null && data[key] !== undefined)
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
    )
    .join("&");
  const finalUrl = queryString ? `${fullUrl}?${queryString}` : fullUrl;

  return fetch(finalUrl, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(data || {}),
  })
    .then((res) => parseResponse(res))
    .catch((err) => {
      console.error("[请求错误]", err);
      throw err;
    });
}

export { BASE_URL };
